// /components/VideoEmbed/InstagramEmbed.js
import React, { useEffect } from 'react';

/**
 * InstagramEmbed Component
 * --------------------------
 * Renders an Instagram embed given a URL.
 * It loads Instagram’s embed script (if not already loaded) and then renders
 * a blockquote that the Instagram script converts into an embedded post/reel.
 *
 * Note: Ensure that your project or page allows external script loading and that
 * the embed script URL is up to date with Instagram's current requirements.
 */
const InstagramEmbed = ({ url }) => {
  useEffect(() => {
    // Check if the Instagram embed script is already loaded
    if (!document.querySelector('script[src="//www.instagram.com/embed.js"]')) {
      const script = document.createElement('script');
      script.src = "//www.instagram.com/embed.js";
      script.async = true;
      document.body.appendChild(script);
      // Optionally trigger a resize after a delay to let the embed render.
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 1000);
    } else {
      // If already loaded, trigger a resize shortly.
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 500);
    }
  }, [url]);

  return (
    <blockquote
      className="instagram-media"
      data-instgrm-permalink={url}
      data-instgrm-version="12"
      style={{ background: '#FFF', border: 0, margin: 0, maxWidth: '540px', width: '100%' }}
    >
      <a href={url} target="_blank" rel="noopener noreferrer">
        View this post on Instagram
      </a>
    </blockquote>
  );
};

export default InstagramEmbed;
